import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../../../../../models/base/base-component';
import { MasterKushStrainIndexCardStackContentViewModel } from '../master-kush-strain-index-card-stack-content-view-model';
import { Variant } from '../../../../../../../../models/product/dto/variant';
import { MasterKushStrainVariantViewModel } from './master-kush-strain-variant-view-model';
import { CardData } from '../../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-master-kush-strain-variant',
  templateUrl: './master-kush-strain-variant.component.html',
  styleUrls: ['./master-kush-strain-variant.component.scss'],
  providers: [MasterKushStrainVariantViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MasterKushStrainVariantComponent extends BaseComponent implements OnChanges {
  constructor(
    public viewModel: MasterKushStrainVariantViewModel,
    public masterKushStrainViewModel: MasterKushStrainIndexCardStackContentViewModel
  ) {
    super();
  }

  @Input() variant: Variant;
  @Input() data: CardData;
  @Input() hasAssortedSizes: boolean = false;

  setupBindings() {}

  setupViews() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.viewModel.connectToRowViewModel(this.data);
    }
  }
}
